// @flow
import { createSelector } from 'reselect';
import _ from 'lodash';
import getTeamsById from '../league/getTeamsById';

export const getUsersFromTeamsById = createSelector(
	getTeamsById,
	(teams_by_id: Object) => _.keyBy(teams_by_id, 'user_id')
);


// WEBPACK FOOTER //
// ./src/modules/selectors/users/index.js